import { FC } from 'react';

export interface CreateOptionItem {
  id: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

interface CreateOptionsProps {
  options: CreateOptionItem[];
}

export const CreateOptions: FC<CreateOptionsProps> = ({ options }) => {
  return (
    <div className="absolute top-full mt-2 left-0 bg-white shadow-lg rounded-lg py-2 w-[12rem] z-10 border border-gray-200">
      {options.map(option => (
        <div
          key={option.id}
          className="flex items-center gap-3 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
          onClick={option.onClick}>
          {option.icon}
          <span className="text-sm font-medium text-[#353535]">
            {option.label}
          </span>
        </div>
      ))}
    </div>
  );
};
